// icon:bx-loader-circle | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";

function IconBxLoaderCircle(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M14 20 A2 2 0 0 1 12 22 A2 2 0 0 1 10 20 A2 2 0 0 1 14 20 z" />
      <path d="M14 4 A2 2 0 0 1 12 6 A2 2 0 0 1 10 4 A2 2 0 0 1 14 4 z" />
      <path d="M8.343 17.657 A2 2 0 0 1 6.343 19.657 A2 2 0 0 1 4.343 17.657 A2 2 0 0 1 8.343 17.657 z" />
      <path d="M19.657 6.343 A2 2 0 0 1 17.657 8.343 A2 2 0 0 1 15.657 6.343 A2 2 0 0 1 19.657 6.343 z" />
      <path d="M6.0009999999999994 12 A2.001 2.001 0 0 1 4 14.001 A2.001 2.001 0 0 1 1.999 12 A2.001 2.001 0 0 1 6.0009999999999994 12 z" />
      <path d="M22 12 A2 2 0 0 1 20 14 A2 2 0 0 1 18 12 A2 2 0 0 1 22 12 z" />
      <path d="M8.343 6.344 A2 2 0 0 1 6.343 8.344000000000001 A2 2 0 0 1 4.343 6.344 A2 2 0 0 1 8.343 6.344 z" />
      <path d="M19.657 17.658 A2 2 0 0 1 17.657 19.658 A2 2 0 0 1 15.657 17.658 A2 2 0 0 1 19.657 17.658 z" />
    </svg>
  );
}

export default IconBxLoaderCircle;
